import apiV2 from './apiV2';

/**
 * ONE-STOP ticket magic-link generator.
 *
 * Every operator surface (Check-In, Dashboard, Relations, Calendar, emails)
 * must use this so all tokens for a customer ticket come from the SAME
 * system: the v2 JWT endpoint (`/api/v2/public/bookings/{code}/generate-magic-link`).
 *
 * Returns the full magic-link URL (https://.../customer-ticket/CODE?token=...).
 * Falls back to a token-less URL only if the backend call fails.
 */
export async function getTicketLink(confirmationCode) {
  try {
    const { data } = await apiV2.post(`/public/bookings/${confirmationCode}/generate-magic-link`);
    if (data?.magicLink) return data.magicLink;
  } catch (error) {
    console.error('getTicketLink: failed to generate magic link', error);
  }
  return `${window.location.origin}/customer-ticket/${confirmationCode}`;
}

export default getTicketLink;
